import { DYNAMIC_REMOTES } from '~/config/app.constants';
import { NavigateFunction } from 'react-router';

import { openModalByName } from '@mindtickle/modal/withModal';

import {
  getModuleFromInitalisedRemote,
  isRemoteIntialised,
} from '@mindtickle/ui-shell-core/DynamicRemote';

export const openSupportModal = ({ navigate }: { navigate: NavigateFunction }) => async () => {
  if (!isRemoteIntialised(DYNAMIC_REMOTES.GET_SUPPORT.remoteName)) return;
  const { remoteName, moduleName } = DYNAMIC_REMOTES.GET_SUPPORT;
  const { MODAL_NAME } = await getModuleFromInitalisedRemote(remoteName, moduleName);
  openModalByName(MODAL_NAME, navigate, { stacking: true });
};
